import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export interface LastFmTrack {
  name: string;
  artist: {
    '#text': string;
    mbid?: string;
  };
  album?: {
    '#text': string;
  };
  image: Array<{
    '#text': string;
    size: string;
  }>;
  url?: string;
  date?: {
    uts: string;
    '#text': string;
  };
  '@attr'?: {
    nowplaying?: string;
  };
}

async function fetchRecentTracks(username: string, limit: number): Promise<LastFmTrack[]> {
  const apiKey = import.meta.env.VITE_LASTFM_API_KEY;
  const response = await axios.get('https://ws.audioscrobbler.com/2.0/', {
    params: {
      method: 'user.getrecenttracks',
      user: username,
      api_key: apiKey,
      format: 'json',
      limit,
    },
  });

  const trackData = response.data?.recenttracks?.track;
  if (!trackData) return [];
  return Array.isArray(trackData) ? trackData : [trackData];
}

export function useRecentScrobbles(username = 'cdbattags', limit = 10) {
  return useQuery({
    queryKey: ['lastfm', 'recent', username, limit],
    queryFn: () => fetchRecentTracks(username, limit),
    staleTime: 25_000,
    refetchInterval: 30_000,
    refetchOnWindowFocus: false,
  });
}
